export const sectionIDs = {
  ACCOUNT_VIEW: 'Account__View',
  BILLING_VIEW: 'Billing__View',
  BIOGRAPHY_VIEW: 'Biography__View',
  PROFILE_VIEW: 'Profile__View',
  SETTINGS_VIEW: 'Settings__View',
  INTEGRATIONS_VIEW: 'Integrations__View',
  USER_DASHBOARD: 'User__Dashboard',
  USER_SETTINGS: 'User__Settings',
  USER_FEED: 'User__Feed',
  AVATAR: 'User__Avatar',
};
